import React from 'react';
import { Box, SvgIconProps, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ClickToCopy } from '../../ClickToCopy';
import { ContactInfoActionButton, ContactInfoActionButtonProps } from '../Modals/session-details-modal/components/ContactInfoRow';
import { useIsMobile } from '@uplift/hooks';


const useStyles = makeStyles({ name: 'ContactInfoRow' })(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '0',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'unset',
    }
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  text: {
    alignItems: 'center',
    display: 'flex',
    fontSize: '14px',
    minWidth: 0,
  },
  primary: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: theme.spacing(0.5),
  },
  secondary: {
    paddingRight: theme.spacing(0.5),
    fontWeight: 400,
  },
  action: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}));


export type UserInfoRowProps = {
  primary: React.ReactNode;
  icon?: React.ElementType<SvgIconProps>;
  iconSpacer?: boolean;
  secondary?: React.ReactNode;
  text?: string;
  type?: ContactInfoActionButtonProps['type'];
  classes?: Partial<ReturnType<typeof useStyles>['classes']>;
};


export const ContactInfoRow: React.FC<UserInfoRowProps> = ({ icon: Icon, primary, secondary, text, type, iconSpacer }) => {
  const isMobile = useIsMobile('sm');
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>
        {Icon && <Icon color="secondary" fontSize="small" />}
        {iconSpacer && <Box width="20px" />}
      </Box>
      <Box className={classes.text}>
        <Typography className={classes.primary}>
          {primary}
        </Typography>
        {secondary && (
          <Typography className={classes.secondary} variant="body2">
            {secondary}
          </Typography>
        )}
      </Box>
      {(text && type !== 'link') && (
        <Box mr={2} flex={0}>
          <ClickToCopy text={text} />
        </Box>
      )}
      {isMobile && type && (
        <Box className={classes.action}>
          <ContactInfoActionButton type={type} value={text} />
        </Box>
      )}
    </Box>
  );
};

